import { render, staticRenderFns } from "./PaymentsLink.vue?vue&type=template&id=d9e9e292&"
import script from "./PaymentsLink.vue?vue&type=script&lang=ts&"
export * from "./PaymentsLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports